<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
                    <el-input v-model="formDatas.acrAmount" style="width: 120px;" size="mini" placeholder="劵面金额"
                        clearable></el-input>
                    <el-input v-model="formDatas.specsSku" style="width: 120px;" size="mini" placeholder="规格编码"
                        clearable></el-input>
                    <el-select v-model="formDatas.specsType" placeholder="请选择规格类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.billShareType" placeholder="请选择分账类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option v-for="item in billShareTypeList" :key="item.asShareTypeId"
                            :label="item.asShareTypeName" :value="item.asShareTypeId"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
          
            <el-button type="success" size="mini" style=" " @click="BoxOpen">新增券码规格</el-button>
          </div>
        </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="specsId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增/编辑 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑券码规格' : '新增券码规格'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商品编码" prop="specsSku">
                                <el-input v-model="form.specsSku" style="width: 80%;" placeholder="请输入商品编码"></el-input>
                            </el-form-item>
                            <el-form-item label="商品名称" prop="specsName">
                                <el-input v-model="form.specsName" style="width: 80%;" placeholder="请输入商品名称"></el-input>
                            </el-form-item>
                            <el-form-item label="劵面金额" prop="acrAmount">
                                <el-input v-model="form.acrAmount" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="规格类型" prop="specsType">
                                <el-select v-model="form.specsType" placeholder="请选择" style="width: 80%;">
                                    <el-option label="普通" :value="1"></el-option>
                                    <el-option label="烟感" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="分账类型" prop="billShareType">
                                <el-select v-model="form.billShareType" placeholder="请选择" style="width: 80%;">
                                    <el-option v-for="item in billShareTypeList" :key="item.asShareTypeId"
                                        :label="item.asShareTypeName" :value="item.asShareTypeId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="排序" prop="specsOrder">
                                <el-input v-model="form.specsOrder" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="specsRemark">
                                <el-input v-model="form.specsRemark" style="width: 80%;" type="textarea" :rows="3"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordSpecsList, addAjefCertificateRecordSpecs, updateAjefCertificateRecordSpecs, deleteAjefCertificateRecordSpecs, getAjefShopBillShareTypeList } from "../../api/api";
export default {
    name: "CertificateRecordSpecs",
    components: {},
    data() {
        return {
            // 分账类型列表
            billShareTypeList: [],
            dialog: false,
            edit: false,
            form: {},
            rules: {},
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                enable: true,
            },
            tableLoading: false,
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "劵面金额",
                    align: "center",
                },
                {
                    field: "specsSku",
                    key: "specsSku",
                    title: "规格编码",
                    align: "center",
                },
                {
                    field: "specsName",
                    key: "specsName",
                    title: "规格名称",
                    align: "center",
                },
                {
                    field: "specsType",
                    key: "specsType",
                    title: "规格类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.specsType == 1) {
                            return '普通'
                        } else if (row.specsType == 2) {
                            return '烟感'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "billShareType",
                    key: "billShareType",
                    title: "分账类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeItem = this.billShareTypeList.find(item => item.asShareTypeId === row.billShareType);
                        return typeItem ? typeItem.asShareTypeName : '';
                    },
                },
                {
                    field: "specsRemark",
                    key: "specsRemark",
                    title: "备注",
                    align: "center",
                },
                {
                    field: "specsNum",
                    key: "specsNum",
                    title: "数量",
                    align: "center",
                },
                {
                    field: "sortOrder",
                    key: "sortOrder",
                    title: "排序",
                    align: "center",
                },
                { field: "createTime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            post: null,
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        this.getBillShareTypeList();
        this.getList();
    },
    mounted() { },
    methods: {
        // 获取分账类型列表
        getBillShareTypeList() {
            getAjefShopBillShareTypeList().then(res => {
                this.billShareTypeList = res.data || [];
            });
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefCertificateRecordSpecs({ specsId: row.specsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjefCertificateRecordSpecs(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefCertificateRecordSpecs(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;
        },
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }
            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.specsId = row.specsId
                    updateAjefCertificateRecordSpecs(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
        },
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];
            const selectedRowKeysCollection = this.selectedRowKeysCollection;
            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
